<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <div
      class="p-field-checkbox d-flex align-items-start"
      :class="checkParentDivClass"
    >
      <Checkbox
        :aria-label="areaLabel"
        :id="id"
        :name="name"
        v-model="inputValue"
        :disabled="disabled"
        :binary="binary"
        :class="[
          {
            'p-invalid': typeof validate !== 'undefined' && validate.$error,
          },
          inputClass,
        ]"
        @change="$emit('change', $event)"
        @click="$emit('click', $event)"
      />
      <label v-if="labelShown" :class="labelClass" :for="id">
        {{ label }}
        <span class="text-danger" v-if="isRequired"> * </span>
      </label>
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import Checkbox from "primevue/checkbox";
export default {
  components: {
    Checkbox,
  },
  props: {
    category: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [Array, String, Boolean],
      default: () => [],
    },
    areaLabel: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    inputClass: {
      type: String,
    },
    labelClass: {
      type: String,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    binary: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    checkParentDivClass: {
      type: String,
      default: "",
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
